import React from "react";
import Div from "../../../../widget/common/ui/Div";
import { TextBlock } from "../../../../widget/common/ui/Text";
import AppTranslation from "../../../../service/app_translation/AppTranslation";
import TextArea from "../../../../widget/common/form/Textarea";
import { DeactivateAccountContextImport } from "../../../../provider/deactivate_account/DeactivateAccountContextProvider";

const DeactivateAccountReasonContent = (props: {
  type?: number | undefined;
}) => {
  const { handleOnChange, reasonField, maxWords } =
    DeactivateAccountContextImport();

  return (
    <form>
      <TextBlock
        fontName="book"
        fontSize="16_17"
        textColor="grey1"
        className=" border-bottom  pb-3"
      >
        {AppTranslation.text("reason_for_leaving")}
      </TextBlock>
      <Div className="pt-2">
        <TextArea
          name="reason"
          rowSize={6}
          placeHolder={AppTranslation.text("type_here_max_200_chars")}
          maxWords={maxWords}
          value={reasonField}
          validate={true}
          handleOnChange={handleOnChange}
        />
      </Div>
    </form>
  );
};

export default DeactivateAccountReasonContent;
